<template>
<!--  <tabBar :idIndex="0"></tabBar>-->
  <div class="barPic">
    <div  data-bs-pause="false" id="carouselExampleCaptions" class="carousel slide" data-bs-ride="carousel">
      <div class="carousel-indicators"  data-pause="false">
        <div class="masks">
          <button
            aria-current="true"
            aria-label="Slide 1"
            class="active"
            data-bs-slide-to="0"
            data-bs-target="#carouselExampleCaptions"
          ></button>
          <button
            aria-label="Slide 2"
            data-bs-slide-to="1"
            data-bs-target="#carouselExampleCaptions"
            type="button"
          ></button>
          <button
            aria-label="Slide 3"
            data-bs-slide-to="2"
            data-bs-target="#carouselExampleCaptions"
            type="button"
          ></button>
          <button
            aria-label="Slide 4"
            data-bs-slide-to="3"
            data-bs-target="#carouselExampleCaptions"
            type="button"
          ></button>
        </div>
      </div>
      <div data-pause="false" class="carousel-inner">

        <div class="carousel-item active" data-bs-interval="3000" >

          <img alt="..." class="bannerImg" src="@/assets/homeImg/homebanner1.png"/>
<!--          <div class="bannerButton">-->
<!--            更多... <span style="position: absolute;right: 1rem">></span>-->
<!--          </div>-->
        </div>
        <div class="carousel-item" data-bs-interval="3000">
          <img alt="..." class="bannerImg" src="@/assets/homeImg/homebanner2.png"/>
        </div>
        <div class="carousel-item" data-bs-interval="3000">
          <img alt="..." class="bannerImg" src="@/assets/homeImg/homebanner3.png"/>
        </div>
        <div class="carousel-item" data-bs-interval="3000">
          <img alt="..." class="bannerImg" src="@/assets/homeImg/homebanner4.png"/>
        </div>
      </div>

    </div>
  </div>

</template>

<script setup>
// import tabBar from '@/components/tabBar/tabIndex.vue'

</script>


<style lang="scss" scoped>
img {
  display: block;
}

.barPic {
  height: 100vh;
  width: 100%;
  overflow: hidden;

  .bannerImg {
    height: 100vh;
   min-width:  100%;
    overflow-x: hidden;
    object-fit: cover;
  }

  .bannerButton {
    position: absolute;
    top: 50%;
    left: 208px;
    z-index: 99;
    width: 221px;
    height: 62px;
    border: 1px solid rgba(255, 255, 255, .4);
    border-radius: 4px;
    line-height: 62px;
    text-align: center;
    color: #ffffff;
    font-size: 17px;
    cursor: pointer;
  }

}

.masks {
  width: 196px;
  height: 32px;
  background: rgba(255, 255, 255, .1);
  display: flex;
  justify-content: space-around;
  align-items: center;
  border-radius: 40px;
}

.carousel-indicators {

  bottom: 73px;

  button {
    width: 10px;
    height: 10px;
    border: none;
    border-radius: 360px !important;
  }
}
</style>
